// ABOUTME: Chores tab for ChildProfilePage — renders ChoresPage in embedded mode scoped to one child
// ABOUTME: Passes familyIdOverride and filterToChildId so ChoresPage skips family loading and shows one child

import ChoresPage from '../ChoresPage';
import { Child } from '../../types/api';

interface ChoresTabProps {
  child: Child;
  familyId: number;
}

export default function ChoresTab({ child, familyId }: ChoresTabProps) {
  const childId = child.childId ?? (child as { id?: number }).id ?? 0;
  return (
    <ChoresPage
      embedded
      filterToChildId={childId}
      familyIdOverride={familyId}
    />
  );
}
